<template>
    <div class="form-floating mb-3">
        <input :type="((this.type) ? this.type : 'text')" :class="'form-control ' + cls" :name="name" :id="name" :placeholder="placeholder" @paste="pasteEmails($event)" v-model="value"
               autocomplete="new-password" role="presentation">
        <label :for="name">{{ title }}</label>
        <transition name="fade" mode="out-in">
            <div class="invalid-feedback text-start" v-if="cls === 'is-invalid'">
                Dit is een verplicht veld
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name:  'TextField',
    props: ['type', 'name', 'title', 'placeholder', 'cls'],
    data() {
        return {
            value: null
        }
    },
    methods: {
        pasteEmails(event) {
            if(this.name === 'recipient_email[]') {
                let paste = (event.clipboardData || window.clipboardData).getData('text');


                const emails = paste.match(/(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g);

                if(emails !== null && emails.length > 0) {
                    event.preventDefault();
                    this.$parent.setEmailAddresses(emails, this);
                }
            }
        }
    }
}
</script>
